export default __webpack_public_path__ + "static/media/viessman.dc75ccbd.svg";